import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { SelectPage } from '../';
import { UserMarketing as User, MasterMarketing as Master, TenderMarketing as Tender, SubscriberMarketing as Subscriber } from '@providers/index';

@Component({
  selector: 'page-list-notification',
  templateUrl: 'page.html'
})
export class ListNotificationPage {

  user:any={};
  params:any={};
  list:any=[];

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public userApi: User,
    public tenderApi: Tender,
    public subsApi: Subscriber,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public modalCtrl : ModalController,
    public navParams: NavParams,
    public alertCtrl: AlertController
    ) {
    
    this.user = this.userApi.data;
    this.params = {

    }
    
  }

  ionViewDidEnter(){
    this.getList();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  
  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params: any = {modul_id:3, user_id:this.user.user_id};
    this.subsApi.getNotifList(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.list = resp.data;
        loading.dismiss();
      }else{
        this.presentToast("Anda belum mendapat notifikasi");
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
    });
  }

  // deleteNotif(notif_list_id){
  //   let loading = this.loadingCtrl.create({
  //     content: 'Please wait...'
  //   });
  //   loading.present();

  //   let params: any = {id : notif_list_id};
  //   this.subsApi.deleteNotif(params).subscribe((resp:any) => {
  //     loading.dismiss(); 
  //     this.getList();
  //   });

  // }


}



// WEBPACK FOOTER //
// ./src/pages/marketing/list_notification/page.ts